// 回放播放器
import PreviewPlayer from './PreviewPlayer';
import utils from '../../utils';

const PlaybackPlayer = function (opts) {
    opts = opts || {};
    if (opts.ctor === false) {
        return;
    }
    this._ctor(opts);
};

const base = PreviewPlayer.prototype;
const pt = PlaybackPlayer.prototype = new PreviewPlayer({ctor:false});

pt.initDom = function(/*opts*/) {
    base.initDom.apply(this, arguments);
};

//发送播放指令
pt.sendPlayCmd = function(camera) {
    this.$mc.sendPlayback(utils.extend({
        width: this.width || this.dom.offsetWidth,
        height: this.height || this.dom.offsetWidth
    }, camera || this.camera));
};

export default PlaybackPlayer;
